import moment from 'moment'
import { PassThroughStatus } from '../../interfaces/passThrough'
import { FilterFieldType, IFilter } from './types'

export const FUNDING_WIRES_FILTERS_CONFIG = [
  {
    field: 'clientName',
    type: FilterFieldType.Autocomplete,
    isSortable: true,
    placeholder: 'Client',
    title: 'Client',
    align: 'left',
  },
  {
    field: 'amount',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Wire Amount',
    align: 'right',
  },
  {
    field: 'sentDate',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Sent date',
    isExternalField: true,
  },
  {
    field: 'boxLink',
    type: FilterFieldType.Empty,
    title: 'Certificate',
    align: 'right',
  },
  {
    field: 'isSent',
    type: FilterFieldType.Boolean,
    isMultiple: true,
    isSortable: true,
    title: 'Action/Status',
    align: 'right',
    options: [
      {
        value: 'all',
        label: 'All',
      },
      {
        value: 'true',
        label: 'Sent',
      },
      {
        value: 'false',
        label: 'Not Sent',
      },
    ],
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    quickFilters: [
      {
        title: 'Today',
        filters: {
          sentDateFrom: moment().format('YYYY-MM-DD'),
          sentDateTo: moment().format('YYYY-MM-DD'),
        },
      },
    ],
  },
] as const satisfies IFilter[]

export const FUNDING_WIRES_PARTICIPANTS_FILTERS_CONFIG = [
  {
    field: 'clientName',
    type: FilterFieldType.Autocomplete,
    isSortable: true,
    placeholder: 'Funding',
    title: 'Funding',
    align: 'left',
  },
  {
    field: 'currentLoanAmount',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Current Loan Balance',
    align: 'right',
    dbField: '"currentLoanAmount"',
  },
  {
    field: 'amount',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Wire Amount',
    align: 'right',
  },
  {
    field: 'newLoanAmount',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'New Loan Balance',
    align: 'right',
    dbField: '"newLoanAmount"',
  },
  {
    field: 'excessAvailibility',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Excess Availability',
    align: 'right',
    dbField: '"excessAvailability"',
  },
  {
    field: 'sentDate',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Sent date',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    quickFilters: [
      {
        title: 'Last 30 Days',
        filters: {
          sentDateFrom: moment().subtract(1, 'month').format('YYYY-MM-DD'),
          sentDateTo: moment().format('YYYY-MM-DD'),
        },
      },
    ],
  },
] as const satisfies IFilter[]

export const PASSTHROUGHS_FILTERS_CONFIG = [
  {
    field: 'clientName',
    type: FilterFieldType.Autocomplete,
    isSortable: true,
    placeholder: 'Client',
    title: 'Client',
  },
  {
    field: 'amount',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Pass-through amount',
    align: 'right',
  },
  {
    field: 'sentDate',
    type: FilterFieldType.Date,
    isSortable: true,
    title: 'Sent date',
    align: 'right',
    isExternalField: true,
  },
  {
    field: 'collectionDays',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Days negative',
    align: 'right',
  },
  {
    field: 'status',
    type: FilterFieldType.List,
    isMultiple: true,
    isSortable: true,
    align: 'right',
    options: [
      {
        value: 'all',
        label: 'All',
      },
      ...Object.values(PassThroughStatus).map((value) => ({
        value,
        label: value,
      })),
    ],
    title: 'Action',
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    quickFilters: [
      {
        title: 'Today',
        filters: {
          sentDateFrom: moment().format('YYYY-MM-DD'),
          sentDateTo: moment().format('YYYY-MM-DD'),
        },
      },
    ],
  },
] as const satisfies IFilter[]
